<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <div style="padding-bottom: 100px" class="">
        <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link
        ><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span
        ><a class="decoration">Employee </a
        ><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span
        ><router-link class="decoration" :to="rosterIndexPath">{{ pageSectionLabel }}</router-link>
        <template v-if="isViewMode">
          <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span
          >{{ viewPageLabel }}
        </template>
        <template v-else>
          <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span
          >{{ createPageLabel }}
        </template>
      </h6>

     
         
        

        <div class=" container-fluid  bdr-rad2 mb-3">
          <div class="">
            <div v-if="!isViewMode" class="row align-items-end roster-toolbar">
              <div class="col-md-3 mb-3">
                <label class="custom-label">Worksite *</label>
                <v-select class="font-size_def" label="label" :options="worksites" v-model="searchForm.worksite"></v-select>
              </div>
              <div class="col-md-2 mb-3">
                <label class="custom-label">Year *</label>
                <input type="number" v-model="searchForm.year" class="form-control bdr-rad font-size_def" />
              </div>
              <div class="col-md-2 mb-3">
                <label class="custom-label">Month *</label>
                <select v-model="searchForm.month" class="form-control bdr-rad font-size_def">
                  <option v-for="option in monthOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
              </div>
              <div class="col-md-5 mb-3 text-right roster-actions">
                <div class="roster-action-wrap">
                  <button class="btn btn-primary mr-2 bdr-rad btn-sm roster-action-btn" @click="searchMonthlyRoster">Search</button>
                  <button
                    v-if="!isViewMode"
                    class="btn btn-outline-primary mr-2 bdr-rad bdr-rad btn-sm roster-action-btn"
                    @click="openWorkIdModal"
                  >
                    Create Work ID
                  </button>
                  <button
                    v-if="!isViewMode"
                    class="btn btn-outline-primary mr-2 bdr-rad bdr-rad btn-sm roster-action-btn"
                    @click="openWorksiteModal"
                  >
                    Create Work Site
                  </button>
                </div>
              </div>
            </div>
            <div class="card custom_bdr_rds shadow">
              <div class="card-body custom_bdr_rds">
                <div v-if="isAiRoster && !isViewMode" class="row ai-roster-criteria">
                  <div
                    v-for="field in aiCriteriaFields"
                    :key="field.key"
                    class="col-md-4 col-lg-2 mb-3 ai-roster-criteria-field"
                  >
                    <label class="custom-label">{{ field.label }}</label>
                    <v-select 
                      class=" ai-criteria-select"
                      label="label"
                      :options="employees"
                      v-model="aiCriteria[field.key]"
                      multiple
                      close-on-select
                      append-to-body
                      :calculate-position="positionRosterEmployeeDropdown"
                    ></v-select>
                  </div>
                  <div class="col-md-4 col-lg-2 mb-3 ai-roster-submit-wrap">
                    <button
                      type="button"
                      class="btn btn-primary bdr-rad btn-sm ai-roster-submit-btn"
                      :disabled="isSavingRoster"
                      @click="submitAiRosterCriteria"
                    >
                      {{ isSavingRoster ? "Submitting..." : "Submit" }}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          
            <div v-if="isAiRoster && !isViewMode && aiLoadingProgress.active" class="card custom_bdr_rds shadow ai-loading-card">
              <div class="card-body custom_bdr_rds ai-loading-body">
                <div class="ai-loading-spinner"></div>
                <div class="ai-loading-progress">
                  Reading roster {{ aiLoadingProgress.current }}/{{ aiLoadingProgress.total }}
                </div>
              </div>
            </div>

            <div v-if="isViewMode" class="roster-view-wrapper">
              <div class="card custom_bdr_rds shadow p-2 mb-1 roster-summary-card">
                <div class="card-body custom_bdr_rds roster-summary-body">
                  <div class="d-flex justify-content-end mb-3">
                    <!-- <button class="btn btn-sm btn-primary bdr-rad" @click="goBackToRosterIndex">
                      <i class="fa fa-arrow-left mr-1"></i> Back
                    </button> -->
                  </div>
                  <div class="table-responsive">
                      <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
                      <tbody>
                        <tr v-for="row in viewSummaryRows" :key="row.label">
                          <th class="width-custom2">{{ row.label }}</th>
                          <td>{{ row.value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

           

              <div class="roster-panel shadow card mt-2">
                <div class="roster-title roster-title-with-info text-center">
                  <span>{{ viewRosterTitle }}</span>
                  <button
                    type="button"
                    class="roster-info-btn"
                    title="Roster read count"
                    @click="openRosterReadCountModal"
                  >
                    <i class="fa fa-info" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="d-flex justify-content-end mb-2">
                  <button
                    v-if="!isActualRoster && selectedRoster && Number(selectedRoster.confirm_status) !== 1"
                    class="btn btn-sm btn-outline-primary bdr-rad mr-2"
                    @click="confirmSchedule"
                  >
                    Confirm
                  </button>
                  <button
                    v-if="isViewMode && !isActualRoster && selectedRoster && Number(selectedRoster.confirm_status) !== 1"
                    class="btn btn-sm btn-outline-primary bdr-rad"
                    @click="updateViewRosterAssignments"
                  >
                    Update
                  </button>
                </div>
                <div class="card-body   roster-table-shell">
                  <div class="  table-responsive roster-table-scroll mb-0">
                    <table class="table table-bordered table-sm table-hover roster-grid roster-view-grid">
                      <thead class="background_color2">
                        <tr>
                          <th class="sticky-col custom-label2">No.</th>
                          <th class="sticky-col custom-label2 roster-employee-col">Work ID</th>
                          <th class="sticky-col custom-label2">Pattern</th>
                          <th class="sticky-col custom-label2 roster-employee-col">Employee</th>
                          <th class="sticky-col custom-label2">Position</th>
                          <th class="custom-label2" v-for="day in monthDays" :key="day.date" :class="['day-head', day.is_weekend ? 'weekend-head' : '']">
                            <div>{{ day.label }}</div>
                            <small>{{ day.short }}</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!filteredRosterRows.length">
                          <td :colspan="5 + monthDays.length">No roster rows found.</td>
                        </tr>
                        <tr v-for="row in filteredRosterRows" :key="row.team_employee_id">
                          <td class="">{{ row.no }}</td>
                          <td class="sticky-col">
                            <template v-if="isActualRoster">
                              <span class="roster-readonly-value">{{ row.work_id_code }}</span>
                            </template>
                            <template v-else>
                              <input
                                v-model="row.work_id_code"
                                type="text"
                                class="form-control form-control-sm roster-inline-input"
                              />
                            </template>
                          </td>
                          <td class="sticky-col">
                            <template v-if="isActualRoster">
                              <span class="roster-readonly-value">{{ row.pattern && row.pattern.label ? row.pattern.label : "Select Pattern" }}</span>
                            </template>
                            <template v-else>
                              <b-dropdown
                                size="sm"
                                variant="outline-primary"
                                class="bdr-rad roster-pattern-dropdown"
                                toggle-class="bdr-rad roster-pattern-toggle"
                                menu-class="bdr-rad roster-pattern-menu"
                                boundary="viewport"
                              >
                                <template #button-content>
                                  {{ row.pattern && row.pattern.label ? row.pattern.label : "Select Pattern" }}
                                </template>
                                <b-dropdown-item
                                  v-for="pattern in patterns"
                                  :key="pattern.value"
                                  :active="row.pattern && row.pattern.value === pattern.value"
                                  @click="updateRosterPattern(row, pattern)"
                                >
                                  {{ pattern.label }}
                                </b-dropdown-item>
                              </b-dropdown>
                            </template>
                          </td>
                          <td class="sticky-col roster-employee-col">
                            <template v-if="isActualRoster">
                              <span class="roster-readonly-value">{{ row.employee && row.employee.label ? row.employee.label : "" }}</span>
                            </template>
                            <template v-else>
                              <v-select
                                class="font-size_def roster-inline-select"
                                label="label"
                                :options="employees"
                                v-model="row.employee"
                                append-to-body
                                :calculate-position="positionRosterEmployeeDropdown"
                              ></v-select>
                            </template>
                          </td>
                          <td class="sticky-col">
                            <template v-if="isActualRoster">
                              <span class="roster-readonly-value">{{ row.position }}</span>
                            </template>
                            <template v-else>
                              <input
                                v-model="row.position"
                                type="text"
                                class="form-control form-control-sm roster-inline-input"
                              />
                            </template>
                          </td>
                          <td
                            v-for="day in monthDays"
                            :key="row.team_employee_id + '-' + day.date"
                            :class="['day-cell', day.is_weekend ? 'weekend-cell' : '', { 'day-cell-clickable': isActualRoster }]"
                            @click="openActualDayModal(row, day)"
                          >
                            {{ resolveRosterDayValue(row, day) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>


               <div v-if="isActualRoster" class="card custom_bdr_rds shadow p-2 mb-1 roster-changes-card">
                <div class="card-body custom_bdr_rds roster-summary-body">
                  <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
                     <div class="roster-title text-center">
                 Actual Duty Roster Changes for {{ selectedWorksiteLabel }} for the Month of {{ selectedMonthLabel }} - {{ searchForm.year }}
                </div>
                    <div class="roster-change-legend">
                      <div
                        v-for="legend in actualChangeLegend"
                        :key="legend.label"
                        class="roster-legend-item"
                      >
                        <span class="roster-legend-swatch" :style="{ background: legend.color }"></span>
                        <span>{{ legend.label }}</span>
                      </div>
                    </div>
                  </div>
                     <div class="card-body   roster-table-shell">
                  <div class="table-responsive">
                    <table class="table table-bordered table-sm table-hover ">
                      <thead class="background_color2">
                        <tr>
                          <th class="custom-label2">No.</th>
                          <th class="custom-label2">Work ID</th>
                          <th class="custom-label2">Employee FIN/NRIC</th>
                          <th class="custom-label2">Employee</th>
                          <th class="custom-label2">Position</th>
                          <th class="custom-label2">Replace Shift By</th>
                          <th class="custom-label2">Shift</th>
                          <th class="custom-label2">Replaced Employee</th>
                          <th class="custom-label2">Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!actualChangeRows.length">
                          <td colspan="9">No changes found.</td>
                        </tr>
                        <tr
                          v-for="row in actualChangeRows"
                          :key="row.id"
                          :class="row.rowClass"
                        >
                          <td>{{ row.no }}</td>
                          <td>{{ row.work_id_code }}</td>
                          <td>{{ row.employee_contact_no }}</td>
                          <td>{{ row.employee_name }}</td>
                          <td>{{ row.position }}</td>
                          <td>{{ row.assignment_label }}</td>
                          <td>{{ row.shift_code }}</td>
                          <td>{{ row.replacement_employee }}</td>
                          <td>{{ row.reason }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>

            <template v-else-if="!isViewMode && !aiLoadingProgress.active">
              <div class="roster-panel mt-4">
                <div class="roster-title roster-title-with-info text-center">
                  <span>Duty Roster for {{ selectedWorksiteLabel }} for the Month of {{ selectedMonthLabel }} - {{ searchForm.year }}</span>
                  <button
                    type="button"
                    class="roster-info-btn"
                    title="Roster read count"
                    @click="openRosterReadCountModal"
                  >
                    <i class="fa fa-info" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="d-flex justify-content-end mb-2">
                  <!-- <button class="btn btn-sm btn-outline-primary bdr-rad" @click="saveRosterAssignments">Save Work ID / Position Assignments</button> -->
                </div>
                <div class="roster-table-shell">
                  <div class="table-responsive  roster-table-scroll mb-0">
                    <table class="table table-bordered  table-sm table-hover roster-grid">
                    <thead class="background_color2">
                      <tr>
                        <th class=" custom-label2">No.</th>
                        <th  class="sticky-col custom-label2 roster-employee-col">Work ID</th>
                        <th class="sticky-col custom-label2">Pattern</th>
                        <th class="sticky-col custom-label2 roster-employee-col">Employee</th>
                        <th class="sticky-col custom-label2">Position</th>
                        <th class="custom-label2" v-for="day in monthDays" :key="day.date" :class="['day-head', day.is_weekend ? 'weekend-head' : '']">
                          <div>{{ day.label }}</div>
                          <small>{{ day.short }}</small>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="!filteredRosterRows.length">
                        <td :colspan="5 + monthDays.length">No roster rows found.</td>
                      </tr>
                      <tr v-for="row in filteredRosterRows" :key="row.team_employee_id">
                        <td class="">{{ row.no }}</td>
                        <td class="sticky-col">
                          <input
                            v-model="row.work_id_code"
                            type="text"
                            class="form-control form-control-sm roster-inline-input"
                            :readonly="isViewMode"
                          />
                        </td>
                        <td class="sticky-col">
                          <template v-if="!isViewMode">
                            <b-dropdown
                              size="sm"
                              variant="outline-primary"
                              class="bdr-rad roster-pattern-dropdown"
                              toggle-class="bdr-rad roster-pattern-toggle"
                              menu-class="bdr-rad roster-pattern-menu"
                              boundary="viewport"
                            >
                              <template #button-content>
                                {{ row.pattern && row.pattern.label ? row.pattern.label : "Select Pattern" }}
                              </template>
                              <b-dropdown-item
                                v-for="pattern in patterns"
                                :key="pattern.value"
                                :active="row.pattern && row.pattern.value === pattern.value"
                                @click="updateRosterPattern(row, pattern)"
                              >
                                {{ pattern.label }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </template>
                          <template v-else>
                            <span class="roster-readonly-value">{{ row.pattern && row.pattern.label ? row.pattern.label : "Select Pattern" }}</span>
                          </template>
                        </td>
                        <td class="sticky-col roster-employee-col">
                          <v-select
                            class="font-size_def roster-inline-select"
                            label="label"
                            :options="employees"
                            v-model="row.employee"
                            :disabled="isViewMode"
                            append-to-body
                            :calculate-position="positionRosterEmployeeDropdown"
                          ></v-select>
                        </td>
                        <td class="sticky-col">
                          <input
                            v-model="row.position"
                            type="text"
                            class="form-control form-control-sm roster-inline-input"
                            :readonly="isViewMode"
                          />
                        </td>
                        <td v-for="day in monthDays" :key="row.team_employee_id + '-' + day.date" :class="['day-cell', day.is_weekend ? 'weekend-cell' : '']">
                          {{ resolveRosterDayValue(row, day) }}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                  </div>


                  
                </div>
                
              </div>
              
      <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
      
      <div class="d-flex  ">
      
      </div>
      <div class="d-flex  ">
          <button
            type="button"
            class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
            :disabled="isSavingRoster"
            @click="saveRosterAssignments"
          >
            {{ isSavingRoster ? "Creating..." : "Create" }}
          </button>
      </div>
      </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showWorksiteModal" title="Create Work Site" hide-footer centered>
      <div class="row">
        <div class="col-md-12 mb-3">
          <label class="custom-label">Work Site Code</label>
          <input
            :key="'worksite-code-' + worksiteModalKey"
            v-model="worksiteForm.work_site_code"
            class="form-control bdr-rad font-size_def"
            autocomplete="new-password"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            name="work_site_code_new"
          />
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Work Site Name</label>
          <input v-model="worksiteForm.work_site_name" class="form-control bdr-rad font-size_def" />
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Address</label>
          <input v-model="worksiteForm.site_address" class="form-control bdr-rad font-size_def" />
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Contact</label>
          <input v-model="worksiteForm.site_contact" class="form-control bdr-rad font-size_def" />
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-outline-secondary bdr-rad mr-2" @click="showWorksiteModal = false">Cancel</button>
        <button class="btn btn-outline-primary bdr-rad" @click="submitWorksite">Save Work Site</button>
      </div>
    </b-modal>

    <b-modal v-model="showWorkIdModal" title="Create Work ID" hide-footer centered>
      <div class="row">
        <div class="col-md-12 mb-3">
          <label class="custom-label">Worksite</label>
          <v-select class="font-size_def" label="label" :options="worksites" v-model="workIdForm.worksite"></v-select>
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Pattern</label>
          <v-select class="font-size_def" label="label" :options="patterns" v-model="workIdForm.pattern"></v-select>
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Work ID</label>
          <input v-model="workIdForm.work_id_code" class="form-control bdr-rad font-size_def" />
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Position</label>
          <input v-model="workIdForm.position" class="form-control bdr-rad font-size_def" />
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-outline-secondary bdr-rad mr-2" @click="showWorkIdModal = false">Cancel</button>
        <button class="btn btn-outline-primary bdr-rad" @click="submitWorkId">Save Work ID</button>
      </div>
    </b-modal>

    <b-modal v-model="showActualDayModal" title="Update Details" hide-footer centered size="lg">
      <div class="row">
        <div class="col-md-4 mb-3">
          <label class="custom-label">Work ID</label>
          <input v-model="actualDayForm.work_id_code" class="form-control bdr-rad font-size_def" readonly />
        </div>
        <div class="col-md-4 mb-3">
          <label class="custom-label">Employee Name</label>
          <input v-model="actualDayForm.employee_name" class="form-control bdr-rad font-size_def" readonly />
        </div>
        <div class="col-md-4 mb-3">
          <label class="custom-label">Position</label>
          <input v-model="actualDayForm.position" class="form-control bdr-rad font-size_def" readonly />
        </div>
        <div class="col-md-4 mb-3">
          <label class="custom-label">Date</label>
          <input v-model="actualDayForm.roster_date" type="date" class="form-control bdr-rad font-size_def" readonly />
        </div>
        <div class="col-md-4 mb-3">
          <label class="custom-label">Select Option</label>
          <select v-model="actualDayForm.assignment_type" class="form-control bdr-rad font-size_def" @change="syncActualShiftCode">
            <option v-for="option in rosterOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="col-md-4 mb-3">
          <label class="custom-label">Shift</label>
          <input v-model="actualDayForm.shift_code" class="form-control bdr-rad font-size_def" />
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Replacement Employee</label>
          <v-select
            class="font-size_def"
            label="label"
            :options="employees"
            v-model="actualDayForm.replacement_employee"
          ></v-select>
        </div>
        <div class="col-md-12 mb-3">
          <label class="custom-label">Remarks</label>
          <textarea v-model="actualDayForm.remarks" rows="3" class="form-control bdr-rad font-size_def"></textarea>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-outline-secondary bdr-rad mr-2" @click="showActualDayModal = false">Cancel</button>
        <button class="btn btn-outline-primary bdr-rad" :disabled="isSavingActualDay" @click="saveActualDay">
          {{ isSavingActualDay ? 'Updating...' : 'Update' }}
        </button>
      </div>
    </b-modal>

    <b-modal v-model="showRosterReadCountModal" title="AI Read Rosters with user selected Parameters" hide-footer size="xl" modal-class="roster-read-top-modal">
      <div class="roster-read-count-modal">
        <div class="roster-read-count-value">{{ rosterReadCountText }}</div>
        <div class="roster-read-count-label">Read roster / Total roster</div>
      </div>
      <div class="table-responsive mt-3">
        <table class="table table-bordered table-sm roster-read-list-table mb-0">
          <thead>
            <tr>
              <th>Roster Code</th>
              <th>Month</th>
              <th>Year</th>
              <th>Must have Name</th>
              <th>Leave out Name</th>
              <th>Night shift Only</th>
              <th>Day shift Only</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rosterReadListRows" :key="`${row.roster_code}-${index}`">
              <td>{{ row.roster_code }}</td>
              <td>{{ row.month }}</td>
              <td>{{ row.year }}</td>
              <td>{{ row.must_have_names }}</td>
              <td>{{ row.leave_out_names }}</td>
              <td>{{ row.night_shift_only }}</td>
              <td>{{ row.day_shift_only }}</td>
            </tr>
            <tr v-if="!rosterReadListRows.length">
              <td colspan="7" class="text-center">No roster records found.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-outline-primary bdr-rad" @click="showRosterReadCountModal = false">OK</button>
      </div>
    </b-modal>

    <content-footer></content-footer>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  name: "RosterAiCreate",
  components: { "v-select": vSelect, TopNavbar, ContentFooter },
  data() {
    const today = new Date();
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      worksites: [],
      patterns: [],
      teamEmployees: [],
      employees: [],
      rosterOptions: [],
      employeePatternHistory: {},
      rosters: [],
      selectedRoster: null,
      selectedScheduleId: null,
      selectedDetails: [],
      selectedActions: [],
      showWorksiteModal: false,
      worksiteModalKey: 0,
      showWorkIdModal: false,
      showActualDayModal: false,
      showRosterReadCountModal: false,
      isSavingActualDay: false,
      isSavingRoster: false,
      aiLoadingProgress: {
        active: false,
        current: 0,
        total: 0,
      },
      rosterReadCount: {
        current: 0,
        total: 0,
      },
      rosterReadListRows: [],
      pageSearch: "",
      rosterSearchSnapshot: [],
      monthlySummary: {
        worksite: null,
        schedule: null,
        month_label: "",
      },
      rosterRows: [],
      leaveRows: [],
      monthOptions: [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" },
      ],
      searchForm: {
        worksite: null,
        year: today.getFullYear(),
        month: today.getMonth() + 1,
      },
      aiCriteriaFields: [
        { key: "must_have_employee_ids", label: "Must have Name" },
        { key: "leave_out_employee_ids", label: "Leave out Name" },
        { key: "position_select_employee_ids", label: "Select Position" },
        { key: "night_shift_employee_ids", label: "Night shift Only" },
        { key: "day_shift_employee_ids", label: "Day shift Only" },
      ],
      aiCriteria: {
        must_have_employee_ids: [],
        leave_out_employee_ids: [],
        position_select_employee_ids: [],
        night_shift_employee_ids: [],
        day_shift_employee_ids: [],
      },
      selectedDetailFields: [
        { key: "roster_date", label: "Date" },
        { key: "employee", label: "Employee" },
        { key: "shift_code", label: "Shift Code" },
        { key: "shift_start", label: "Start" },
        { key: "shift_end", label: "End" },
        { key: "assignment_type", label: "Type" },
        { key: "vacancy_reason", label: "Vacancy" },
        { key: "replacement_employee", label: "Replacement" },
        { key: "remarks", label: "Remarks" },
      ],
      selectedActionFields: [
        { key: "action_type", label: "Action" },
        { key: "employee_id", label: "Employee" },
        { key: "replacement_employee_id", label: "Replacement" },
        { key: "action_date", label: "Date" },
        { key: "remarks", label: "Remarks" },
      ],
      detailFields: [
        { key: "roster_date", label: "Date" },
        { key: "employee", label: "Employee" },
        { key: "team_employee", label: "Team Employee" },
        { key: "shift_code", label: "Shift" },
        { key: "shift_start", label: "Start" },
        { key: "shift_end", label: "End" },
        { key: "assignment_type", label: "Type" },
        { key: "vacancy_reason", label: "Vacancy" },
        { key: "replacement_employee", label: "Replacement" },
        { key: "remarks", label: "Remarks" },
      ],
      worksiteForm: {
        work_site_code: "",
        work_site_name: "",
        site_address: "",
        site_contact: "",
      },
      teamEmployeeForm: {
        worksite: null,
        employee: null,
        work_id_code: "",
        start_code: "",
      },
      workIdForm: {
        worksite: null,
        pattern: null,
        work_id_code: "",
        position: "",
      },
      scheduleForm: {
        schedule_code: "",
        worksite: null,
        pattern: null,
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        start_code: "",
      },
      detailSelectedSchedule: null,
      detailRow: {
        roster_date: "",
        employee: null,
        team_employee: null,
        shift_code: "",
        shift_start: "",
        shift_end: "",
        assignment_type: "normal",
        vacancy_reason: "",
        replacement_employee: null,
        remarks: "",
        status: 1,
      },
      detailRows: [],
      actualDayForm: {
        roster_date: "",
        team_employee_id: 0,
        employee_id: 0,
        work_id_code: "",
        employee_name: "",
        position: "",
        shift_code: "",
        assignment_type: "normal",
        replacement_employee: null,
        replacement_employee_id: 0,
        remarks: "",
      },
      actionForm: {
        schedule: null,
        action_type: "vacancy",
        employee: null,
        replacement_employee: null,
        from_worksite: null,
        to_worksite: null,
        action_date: "",
        remarks: "",
      },
      viewMode: false,
    };
  },
  mounted() {
    this.loadMasterData().then(() => {
      this.applyRouteMode();
    });
  },
  computed: {
    isActualRoster() {
      return this.$route.path.includes("/roster/actual");
    },
    isAiRoster() {
      return this.$route.path.includes("/roster/ai");
    },
    isViewMode() {
      return this.viewMode;
    },
    filteredLeaveRows() {
      const term = String(this.pageSearch || "").trim().toLowerCase();
      if (!term) return this.leaveRows;
      return this.leaveRows.filter((row) =>
        [row.employee, row.fin_nic, row.position, row.site, row.leave_type, row.from_date, row.to_date]
          .join(" ")
          .toLowerCase()
          .includes(term)
      );
    },
    filteredRosterRows() {
      const term = String(this.pageSearch || "").trim().toLowerCase();
      if (!term) return this.rosterRows;
      return this.rosterRows.filter((row) =>
        [row.no, row.work_id_code, row.employee_contact_no, row.employee_name, row.employee ? row.employee.label : "", row.position, row.site]
          .join(" ")
          .toLowerCase()
          .includes(term)
      );
    },
    filteredRosterCountText() {
      const total = this.rosterRows.length;
      const visible = this.filteredRosterRows.length;
      return `${visible} / ${total} items`;
    },
    rosterReadCountText() {
      const progressCurrent = Number(this.aiLoadingProgress && this.aiLoadingProgress.current) || 0;
      const progressTotal = Number(this.aiLoadingProgress && this.aiLoadingProgress.total) || 0;
      const current = Number(this.rosterReadCount.current) || progressCurrent || progressTotal || this.rosterRows.length || 0;
      const total = Number(this.rosterReadCount.total) || progressTotal || current;
      return `${current}/${total}`;
    },
    rosterReadListInfo() {
      const summary = this.activeRosterSummary || {};
      const criteriaLabels = summary.ai_criteria_labels || {};
      return {
        roster_code: summary.schedule_code || "-",
        month: summary.month_label || this.selectedMonthLabel || "-",
        year: summary.year || this.searchForm.year || "-",
        must_have_names: criteriaLabels.must_have_names || "-",
        leave_out_names: criteriaLabels.leave_out_names || "-",
        night_shift_only: criteriaLabels.night_shift_only || "-",
        day_shift_only: criteriaLabels.day_shift_only || "-",
      };
    },
    actualChangeRows() {
      if (!this.isActualRoster) {
        return [];
      }

      const details = Array.isArray(this.selectedDetails) ? this.selectedDetails : [];
      const actions = Array.isArray(this.selectedActions) ? this.selectedActions : [];
      const rows = [];

      details.forEach((detail, index) => {
        const rosterRow = this.rosterRows.find((row) => {
          const rowTeamEmployeeId = Number(row.team_employee_id || 0);
          const detailTeamEmployeeId = Number(detail.team_employee_id || 0);
          const rowEmployeeId = Number(row.employee_id || 0);
          const detailEmployeeId = Number(detail.employee_id || 0);
          return (
            (detailTeamEmployeeId > 0 && rowTeamEmployeeId === detailTeamEmployeeId) ||
            (detailEmployeeId > 0 && rowEmployeeId === detailEmployeeId)
          );
        }) || null;

        const action = actions.find((item) => {
          const actionEmployeeId = Number(item.employee_id || 0);
          const actionDate = String(item.action_date || "");
          const detailEmployeeId = Number(detail.employee_id || 0);
          return String(detail.roster_date || "") === actionDate && detailEmployeeId === actionEmployeeId;
        }) || {};

        const actualShift = String(detail.shift_code || detail.assignment_type || action.action_type || "").trim();
        const expectedShift = rosterRow ? this.expectedRosterDayValue(rosterRow, detail.roster_date) : "";
        const normalizedActual = this.normalizeActualChangeType(actualShift);
        const normalizedExpected = this.normalizeActualChangeType(expectedShift);
        const normalizedAction = this.normalizeActualChangeType(action.action_type || "");
        const isExplicitAction = normalizedAction !== "";
        const isChangedFromPattern = normalizedActual && normalizedActual !== normalizedExpected;

        if (!isExplicitAction && !isChangedFromPattern) {
          return;
        }

        rows.push({
          id: action.id || detail.id || `${detail.roster_date || "change"}-${detail.employee_id || index}`,
          no: index + 1,
          work_id_code: rosterRow ? rosterRow.work_id_code || "-" : "-",
          employee_contact_no: detail.fin_nic || detail.employee_contact_no || "-",
          employee_name: detail.employee || (rosterRow && rosterRow.employee ? rosterRow.employee.label : "-"),
          position: rosterRow ? rosterRow.position || "-" : "-",
          assignment_label: this.actualChangeAssignmentLabel({
            ...detail,
            action_type: action.action_type,
            shift_code: actualShift,
          }),
          shift_code: actualShift || "-",
          replacement_employee: detail.replacement_employee || "-",
          reason: detail.vacancy_reason || detail.remarks || action.remarks || "-",
          rowClass: this.actualChangeRowClass({
            ...detail,
            action_type: action.action_type,
            shift_code: actualShift,
          }),
        });
      });

      return rows;
    },
    actualChangeLegend() {
      return [
        { label: "Vacancy", color: "#7f7f7f" },
        { label: "Medical Leave", color: "#f2e700" },
        { label: "Leave", color: "#ef5350" },
        { label: "Training", color: "#4a73ff" },
        { label: "Other / Employee Transfer", color: "#7be03f" },
      ];
    },
    selectedMonthLabel() {
      return (this.monthOptions.find((item) => item.value === Number(this.searchForm.month)) || {}).label || "";
    },
    selectedWorksiteLabel() {
      return this.searchForm.worksite ? this.searchForm.worksite.label : "";
    },
    pageSectionLabel() {
      if (this.isAiRoster) {
        return "Manage AI Schedule Roster";
      }
      return this.isActualRoster ? "Manage Roster" : "Manage Schedule Roster";
    },
    rosterIndexPath() {
      if (this.isAiRoster) return "/roster/ai/index";
      return this.isActualRoster ? "/roster/actual/index" : "/roster/index";
    },
    rosterViewPath() {
      return this.isAiRoster ? "/roster/ai/view" : "/roster/view";
    },
    viewPageLabel() {
      if (this.isAiRoster) return "View AI Schedule roster";
      return this.isActualRoster ? "View Roster" : "View Schedule roster";
    },
    createPageLabel() {
      if (this.isAiRoster) return "Create AI Schedule roster";
      return this.isActualRoster ? "Create Roster" : "Create Schedule roster";
    },
    monthlyEndpoint() {
      return this.isAiRoster ? "/roster/aimonthly" : "/roster/monthly";
    },
    rosterListEndpoint() {
      return this.isAiRoster ? "/roster/aiindex" : "/roster/index";
    },
    rosterViewEndpoint() {
      return this.isAiRoster ? "/roster/aiview" : "/roster/view";
    },
    createScheduleEndpoint() {
      return this.isAiRoster ? "/roster/aicreateschedule" : "/roster/createschedule";
    },
    addDetailEndpoint() {
      return this.isAiRoster ? "/roster/aiadddetail" : "/roster/adddetail";
    },
    activeRosterSummary() {
      return this.selectedRoster || (this.monthlySummary && this.monthlySummary.schedule) || null;
    },
    viewRosterTitle() {
      const summary = this.activeRosterSummary || {};
      const siteName = summary.site || summary.worksite || this.selectedWorksiteLabel || "";
      const monthLabel = summary.month_label || this.selectedMonthLabel || "";
      const year = summary.year || this.searchForm.year || "";
      return `Duty Roster for ${siteName || "Work Site"} for the Month of ${monthLabel} - ${year}`;
    },
    viewSummaryRows() {
      const summary = this.activeRosterSummary || {};
      const fallbackWorksite = this.selectedWorksiteLabel || "-";
      const fallbackMonth = this.selectedMonthLabel || "-";
      const rows = [
        { label: "ID", value: summary.id || "-" },
        { label: "Roster Code", value: summary.schedule_code || "-" },
        { label: "Month", value: summary.month_label || fallbackMonth },
        { label: "Year", value: summary.year || this.searchForm.year || "-" },
        { label: "Start Date", value: summary.start_date || "-" },
        { label: "End Date", value: summary.end_date || "-" },
        { label: "Work ID", value: summary.worksite_code || summary.worksite_id || summary.worksite || fallbackWorksite },
        { label: "Site Name", value: summary.worksite_name || summary.site || summary.worksite || fallbackWorksite },
        { label: "Created Date", value: summary.created_date || "-" },
        { label: "Created By", value: summary.created_by || "-" },
        { label: "Confirmed Date", value: summary.confirmed_date || "-" },
        { label: "Confirmed By", value: summary.confirmed_by || "-" },
        { label: "Status", value: summary.status_label || (summary.confirm_status ? "Confirm" : "Draft") },
      ];
      if (this.isAiRoster) {
        const criteriaLabels = summary.ai_criteria_labels || {};
        rows.push(
          { label: "Must have Name", value: criteriaLabels.must_have_names || "-" },
          { label: "Leave out Name", value: criteriaLabels.leave_out_names || "-" },
          { label: "Position Select", value: criteriaLabels.position_select || "-" },
          { label: "Night shift Only", value: criteriaLabels.night_shift_only || "-" },
          { label: "Day shift Only", value: criteriaLabels.day_shift_only || "-" }
        );
      }
      return rows;
    },
    monthDays() {
      return this.buildMonthDays(this.searchForm.year, this.searchForm.month);
    },
  },
  watch: {
    detailSelectedSchedule(value) {
      if (value) {
        this.selectedScheduleId = value.value;
      }
    },
    "actionForm.schedule"(value) {
      if (value) {
        this.selectedScheduleId = value.value;
      }
    },
    "searchForm.month"() {
      if (!this.isViewMode) {
        this.autoRefreshMonthlyRoster();
      }
    },
    "searchForm.year"() {
      if (!this.isViewMode) {
        this.autoRefreshMonthlyRoster();
      }
    },
    "searchForm.worksite"() {
      this.scheduleForm.worksite = this.searchForm.worksite;
      if (!this.isViewMode) {
        this.autoRefreshMonthlyRoster();
      }
    },
    "$route.query.id"() {
      this.applyRouteMode();
    },
  },
  methods: {
    rosterRequestHeaders() {
      return {
        Authorization: "Bearer " + this.access_token,
        "Content-Type": "application/json",
      };
    },
    positionRosterEmployeeDropdown(dropdownList, component, { width, top, left }) {
      dropdownList.classList.add("ai-employee-dropdown-menu");
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
      dropdownList.style.minWidth = "230px";
      dropdownList.style.maxHeight = "240px";
      dropdownList.style.zIndex = "3000";
      dropdownList.style.fontSize = "13px";
      dropdownList.style.lineHeight = "1.2";
    },
    rosterReadValue(value) {
      const normalized = String(value || "").trim();
      return normalized || "-";
    },
    rosterSortValue(row) {
      const code = String(row && (row.schedule_code || row.roster_code || "")).trim();
      const match = code.match(/(?:[A-Z]+-)?(\d{4})-(\d{5})$/i);
      if (match) {
        return (Number(match[1]) || 0) * 100000 + (Number(match[2]) || 0);
      }

      const directId = Number(row && (row.id || row.schedule_id || row.roster_id || 0));
      return directId > 0 ? directId : 0;
    },
    rosterCreatedTimestamp(row) {
      const value = String(row && (row.created_date || row.createdDate || "")).trim();
      if (!value) {
        return 0;
      }

      const normalized = value.replace(" ", "T");
      const timestamp = Date.parse(normalized);
      return Number.isNaN(timestamp) ? 0 : timestamp;
    },
    filterBeforeCurrentRosterRows(rows) {
      const currentRoster = this.activeRosterSummary || this.selectedRoster || {};
      const normalizedRows = Array.isArray(rows) ? rows : [];
      const currentTimestamp = this.rosterCreatedTimestamp(currentRoster);

      if (currentTimestamp > 0) {
        return normalizedRows.filter((row) => {
          const rowTimestamp = this.rosterCreatedTimestamp(row);
          if (rowTimestamp > 0) {
            return rowTimestamp < currentTimestamp;
          }

          return this.rosterSortValue(row) < this.rosterSortValue(currentRoster);
        });
      }

      const currentSequence = this.rosterSortValue(currentRoster);
      if (currentSequence <= 0) {
        return normalizedRows;
      }

      return normalizedRows.filter((row) => this.rosterSortValue(row) < currentSequence);
    },
    normalizeRosterReadListRows(rows) {
      return (rows || []).map((row) => {
        const criteriaLabels = row.ai_criteria_labels || {};
        return {
          roster_code: this.rosterReadValue(row.schedule_code),
          month: this.rosterReadValue(row.month_label),
          year: this.rosterReadValue(row.year),
          must_have_names: this.rosterReadValue(criteriaLabels.must_have_names),
          leave_out_names: this.rosterReadValue(criteriaLabels.leave_out_names),
          night_shift_only: this.rosterReadValue(criteriaLabels.night_shift_only),
          day_shift_only: this.rosterReadValue(criteriaLabels.day_shift_only),
        };
      });
    },
    async openRosterReadCountModal() {
      await this.refreshRosterReadCount();
      this.showRosterReadCountModal = true;
    },
    async refreshRosterReadCount() {
      if (this.aiLoadingProgress && this.aiLoadingProgress.total) {
        this.rosterReadCount = {
          current: this.rosterReadListRows.length || this.aiLoadingProgress.total,
          total: this.aiLoadingProgress.total,
        };
        return;
      }
      const total = await this.loadTotalScheduleRosterCount();
      this.rosterReadCount = {
        current: this.rosterReadListRows.length || total,
        total,
      };
    },
    selectedEmployeeIds(items) {
      return (items || [])
        .map((item) => Number(item && item.value ? item.value : item))
        .filter((id) => id > 0);
    },
    mapEmployeeIdsToOptions(ids) {
      return (ids || [])
        .map((id) => this.employees.find((employee) => Number(employee.value) === Number(id)))
        .filter(Boolean);
    },
    aiCriteriaPayload() {
      return {
        must_have_employee_ids: this.selectedEmployeeIds(this.aiCriteria.must_have_employee_ids),
        leave_out_employee_ids: this.selectedEmployeeIds(this.aiCriteria.leave_out_employee_ids),
        position_select_employee_ids: this.selectedEmployeeIds(this.aiCriteria.position_select_employee_ids),
        night_shift_employee_ids: this.selectedEmployeeIds(this.aiCriteria.night_shift_employee_ids),
        day_shift_employee_ids: this.selectedEmployeeIds(this.aiCriteria.day_shift_employee_ids),
      };
    },
    applyAiCriteriaFromSchedule(schedule) {
      const criteria = schedule && schedule.ai_criteria ? schedule.ai_criteria : {};
      this.aiCriteria = {
        must_have_employee_ids: this.mapEmployeeIdsToOptions(criteria.must_have_names || []),
        leave_out_employee_ids: this.mapEmployeeIdsToOptions(criteria.leave_out_names || []),
        position_select_employee_ids: this.mapEmployeeIdsToOptions(criteria.position_select || []),
        night_shift_employee_ids: this.mapEmployeeIdsToOptions(criteria.night_shift_only || []),
        day_shift_employee_ids: this.mapEmployeeIdsToOptions(criteria.day_shift_only || []),
      };
    },
    async loadMasterData() {
      try {
        const { data } = await axios.get("/roster/masterdata", { headers: this.rosterRequestHeaders() });
        this.worksites = data.worksites || [];
        this.patterns = data.patterns || [];
        this.teamEmployees = data.team_employees || [];
        this.employees = data.employees || [];
        this.rosterOptions = data.roster_options || [];
        this.employeePatternHistory = data.ai_employee_pattern_history || {};
        const codes = data.suggested_codes || {};
        this.worksiteForm.work_site_code = codes.work_site_code || "";
        this.teamEmployeeForm.work_id_code = codes.work_id_code || "";
        this.workIdForm.work_id_code = codes.work_id_code || "";
        this.scheduleForm.schedule_code = codes.schedule_code || "";
        this.scheduleForm.start_code = codes.start_code || "";
        if (this.searchForm.worksite) {
          const matchedWorksite = this.worksites.find((item) => item.value === this.searchForm.worksite.value);
          this.searchForm.worksite = matchedWorksite || this.worksites[0] || null;
        } else if (this.worksites.length) {
          this.searchForm.worksite = this.worksites[0];
        }
        this.scheduleForm.worksite = this.searchForm.worksite;
      } catch (error) {
        console.log(error.response || error);
      }
    },
    autoRefreshMonthlyRoster() {
      if (!this.searchForm.worksite) return;
      this.searchMonthlyRoster();
    },
    goBackToRosterIndex() {
      this.$router.push(this.rosterIndexPath);
    },
    async applyRouteMode() {
      const id = Number(this.$route.query.id || 0);
      const worksiteId = Number(this.$route.query.worksite_id || 0);
      const year = Number(this.$route.query.year || this.searchForm.year);
      const month = Number(this.$route.query.month || this.searchForm.month);
      if (id > 0) {
        this.viewMode = true;
        await this.loadRosterView(id);
        return;
      }
      if (worksiteId > 0) {
        this.viewMode = true;
        this.searchForm.year = year || this.searchForm.year;
        this.searchForm.month = month || this.searchForm.month;
        this.searchForm.worksite =
          this.worksites.find((item) => item.value === worksiteId) || this.searchForm.worksite;
        this.scheduleForm.worksite = this.searchForm.worksite;
        await this.searchMonthlyRoster();
        return;
      }
      this.viewMode = false;
      if (this.searchForm.worksite) {
        this.scheduleForm.worksite = this.searchForm.worksite;
        await this.searchMonthlyRoster();
      }
    },
    buildMonthDays(year, month) {
      const result = [];
      const currentYear = Number(year) || new Date().getFullYear();
      const currentMonth = Number(month) || new Date().getMonth() + 1;
      const totalDays = new Date(currentYear, currentMonth, 0).getDate();
      for (let day = 1; day <= totalDays; day += 1) {
        const date = new Date(currentYear, currentMonth - 1, day);
        const weekday = date.getDay();
        result.push({
          date: `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
          label: String(day).padStart(2, "0"),
          short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][weekday],
          is_weekend: weekday === 0 || weekday === 6,
        });
      }
      return result;
    },
    patternSequence(patternText) {
      const source = String(patternText || "").trim();
      if (!source) return [];
      const tokens = source.split(/[^A-Za-z0-9]+/).filter(Boolean);
      if (tokens.length > 1) {
        return tokens.map((token) => token.charAt(0).toUpperCase());
      }
      const normalized = source.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
      if (!normalized) return [];
      if (normalized.length === 1) return [normalized];
      return normalized.split("");
    },
    patternSourceText(pattern) {
      if (!pattern) return "";
      return (
        pattern.label ||
        pattern.pattern_code ||
        pattern.pattern_name ||
        pattern.pattern_description ||
        ""
      );
    },
    clonePatternOption(pattern) {
      return pattern ? { ...pattern } : null;
    },
    aiFixedPatternOption(code) {
      const normalizedCode = String(code || "").trim().toUpperCase();
      const pattern = this.patterns.find((item) => {
        const candidates = [
          item.label,
          item.pattern_code,
          item.pattern_name,
          item.pattern_description,
        ];
        return candidates.some((value) => String(value || "").trim().toUpperCase() === normalizedCode);
      });

      return this.clonePatternOption(pattern) || {
        label: normalizedCode,
        value: 0,
        pattern_code: normalizedCode,
        pattern_name: normalizedCode,
        pattern_description: normalizedCode,
      };
    },
    patternCodeText(pattern) {
      return String(this.patternSourceText(pattern)).trim().toUpperCase();
    },
    isFixedAiPattern(pattern) {
      const code = this.patternCodeText(pattern);
      return code === "N" || code === "D";
    },
    aiHistoryPatternOption(employeeId, defaultPattern) {
      const normalizedEmployeeId = Number(employeeId || 0);
      const history = this.employeePatternHistory && this.employeePatternHistory[normalizedEmployeeId]
        ? this.employeePatternHistory[normalizedEmployeeId]
        : null;
      if (!history) {
        return null;
      }

      const candidates = [
        history.pattern_id,
        history.value,
        history.pattern_code,
        history.pattern_name,
        history.pattern_description,
      ];

      for (const candidate of candidates) {
        if (candidate === null || candidate === undefined || candidate === "") {
          continue;
        }

        const candidateId = Number(candidate);
        if (Number.isFinite(candidateId) && candidateId > 0) {
          const matchById = this.patterns.find((pattern) => Number(pattern.value || pattern.id) === candidateId);
        if (matchById && !this.isFixedAiPattern(matchById)) {
            return this.clonePatternOption(matchById);
          }
        }

        const normalizedCode = String(candidate).trim().toUpperCase();
        if (!normalizedCode) {
          continue;
        }

        const matchByText = this.patterns.find((pattern) => {
          const values = [
            pattern.label,
            pattern.pattern_code,
            pattern.pattern_name,
            pattern.pattern_description,
          ];
          return values.some((value) => String(value || "").trim().toUpperCase() === normalizedCode);
        });
        if (matchByText && !this.isFixedAiPattern(matchByText)) {
          return this.clonePatternOption(matchByText);
        }
      }

      return null;
    },
    stablePatternIndex(seed, total) {
      if (!total) return 0;
      const source = String(seed || "");
      let hash = 0;
      for (let index = 0; index < source.length; index += 1) {
        hash = ((hash << 5) - hash) + source.charCodeAt(index);
        hash |= 0;
      }
      return Math.abs(hash) % total;
    },
    aiRandomPatternOption(employeeId, rowIndex, defaultPattern) {
      const normalPatterns = this.patterns.filter((pattern) => !this.isFixedAiPattern(pattern));
      const availablePatterns = normalPatterns.length ? normalPatterns : this.patterns;
      if (!availablePatterns.length) {
        return this.clonePatternOption(defaultPattern);
      }

      const seed = [
        this.searchForm.worksite ? this.searchForm.worksite.value : "",
        this.searchForm.year || "",
        this.searchForm.month || "",
        employeeId,
        rowIndex,
      ].join("-");
      return this.clonePatternOption(availablePatterns[this.stablePatternIndex(seed, availablePatterns.length)] || defaultPattern);
    },
    aiPatternForEmployee(employeeId, defaultPattern, dayOnlyIds, nightOnlyIds, rowIndex = 0) {
      const normalizedEmployeeId = Number(employeeId || 0);
      if (nightOnlyIds.has(normalizedEmployeeId)) {
        return this.aiFixedPatternOption("N");
      }
      if (dayOnlyIds.has(normalizedEmployeeId)) {
        return this.aiFixedPatternOption("D");
      }
      const historyPattern = this.aiHistoryPatternOption(normalizedEmployeeId, defaultPattern);
      if (historyPattern) {
        return historyPattern;
      }
      return this.aiRandomPatternOption(normalizedEmployeeId, rowIndex, defaultPattern);
    },
    expectedRosterDayValue(row, rosterDate) {
      const patternText = this.patternSourceText(row ? row.pattern : null);
      const sequence = this.patternSequence(patternText);
      if (!sequence.length) {
        return "";
      }

      const dayNumber = Number(String(rosterDate || "").slice(-2));
      if (!Number.isFinite(dayNumber) || dayNumber <= 0) {
        return "";
      }

      const index = (dayNumber - 1) % sequence.length;
      return sequence[index] || "";
    },
    buildPatternDayMap(pattern) {
      const patternText = this.patternSourceText(pattern);
      const sequence = this.patternSequence(patternText);
      const dayMap = {};
      this.monthDays.forEach((day) => {
        const dayNumber = Number(String(day.date).slice(-2));
        const index = Number.isFinite(dayNumber) && dayNumber > 0 ? (dayNumber - 1) % (sequence.length || 1) : 0;
        dayMap[day.date] = sequence.length ? (sequence[index] || "N") : "N";
      });
      return dayMap;
    },
    resolveRosterDayValue(row, day) {
      if (this.isActualRoster) {
        const detail = this.selectedDetails.find((item) =>
          item.roster_date === day.date &&
          (
            Number(item.team_employee_id) === Number(row.team_employee_id) ||
            (!item.team_employee_id && Number(item.employee_id) === Number(row.employee ? row.employee.value : row.employee_id || 0))
          )
        );
        if (detail) {
          return detail.shift_code || detail.assignment_type || "N";
        }
      }

      const patternText = this.patternSourceText(row.pattern);
      const sequence = this.patternSequence(patternText);
      if (!sequence.length) {
        const currentValue = row.days && row.days[day.date] ? row.days[day.date] : "";
        return currentValue || "N";
      }

      const dayNumber = Number(String(day.date).slice(-2));
      const index = Number.isFinite(dayNumber) && dayNumber > 0 ? (dayNumber - 1) % sequence.length : 0;
      return sequence[index] || "N";
    },
    defaultRosterOption() {
      return (this.rosterOptions.find((option) => option.option_name === "Default") || {}).value || "";
    },
    normalizeRosterOption(value) {
      const normalizedValue = String(value || "").trim().toLowerCase();
      const match = this.rosterOptions.find((option) =>
        String(option.value).toLowerCase() === normalizedValue ||
        String(option.option_code).toLowerCase() === normalizedValue
      );
      return match ? match.value : this.defaultRosterOption();
    },
    normalizeActualChangeType(value) {
      return String(value || "").trim().toLowerCase().replace(/[\s_-]+/g, " ");
    },
    actualChangeAssignmentLabel(detail) {
      const normalized = this.normalizeActualChangeType(detail.assignment_type || detail.shift_code || "");
      if (!normalized) {
        return "-";
      }

      const rosterOption = this.rosterOptions.find((option) => {
        const optionValue = this.normalizeActualChangeType(option.value || "");
        const optionCode = this.normalizeActualChangeType(option.option_code || "");
        const optionName = this.normalizeActualChangeType(option.option_name || "");
        return optionValue === normalized || optionCode === normalized || optionName === normalized;
      });

      if (rosterOption) {
        return rosterOption.label || rosterOption.option_name || rosterOption.option_code || detail.assignment_type || detail.shift_code || "-";
      }

      if (normalized.includes("vacancy")) return "Vacancy";
      if (normalized.includes("medical")) return "Medical Leave";
      if (normalized.includes("leave")) return "Leave";
      if (normalized.includes("training")) return "Training";
      if (normalized.includes("transfer")) return "Other / Employee Transfer";

      return detail.assignment_type || detail.shift_code || "-";
    },
    actualChangeRowClass(detail) {
      const normalized = this.normalizeActualChangeType(detail.assignment_type || detail.shift_code || "");
      if (normalized.includes("vacancy")) return "change-row-vacancy";
      if (normalized.includes("medical")) return "change-row-medical";
      if (normalized.includes("leave")) return "change-row-leave";
      if (normalized.includes("training")) return "change-row-training";
      if (normalized.includes("transfer")) return "change-row-transfer";
      return "change-row-default";
    },
    openActualDayModal(row, day) {
      if (!this.isActualRoster || !this.selectedScheduleId) return;

      const employeeId = row.employee ? Number(row.employee.value) : 0;
      const existingDetail = this.selectedDetails.find((detail) =>
        detail.roster_date === day.date &&
        (Number(detail.team_employee_id) === Number(row.team_employee_id) ||
          (!detail.team_employee_id && Number(detail.employee_id) === employeeId))
      );

      this.actualDayForm = {
        roster_date: day.date,
        team_employee_id: Number(row.team_employee_id),
        employee_id: employeeId,
        work_id_code: row.work_id_code || "",
        employee_name: row.employee ? row.employee.label : row.employee_name || "",
        position: row.position || "",
        assignment_type: this.normalizeRosterOption(existingDetail ? existingDetail.assignment_type : ""),
        replacement_employee:
          this.employees.find((item) => Number(item.value) === Number(existingDetail ? existingDetail.replacement_employee_id : 0)) ||
          null,
        replacement_employee_id: Number(existingDetail ? existingDetail.replacement_employee_id : 0),
        remarks: existingDetail ? existingDetail.remarks || "" : "",
      };
      this.actualDayForm.shift_code = this.resolveActualShiftCode(
        this.actualDayForm.assignment_type,
        existingDetail ? existingDetail.shift_code : this.resolveRosterDayValue(row, day)
      );
      this.syncActualShiftCode();
      this.showActualDayModal = true;
    },
    resolveActualShiftCode(assignmentType, currentShiftCode = "") {
      const normalized = this.normalizeRosterOption(assignmentType);
      const rosterOption = this.rosterOptions.find((option) => option.value === normalized || option.option_code === normalized);
      const optionCode = String(rosterOption ? rosterOption.option_code : normalized || "").trim().toUpperCase();
      return optionCode || String(currentShiftCode || "").trim();
    },
    syncActualShiftCode() {
      const optionCode = String(this.actualDayForm.assignment_type || "").trim().toUpperCase();
      this.actualDayForm.shift_code = optionCode || this.actualDayForm.shift_code;
    },
    async saveActualDay() {
      this.isSavingActualDay = true;
      try {
        this.syncActualShiftCode();
        const replacementEmployeeId = this.actualDayForm.replacement_employee
          ? Number(this.actualDayForm.replacement_employee.value || 0)
          : Number(this.actualDayForm.replacement_employee_id || 0);
        const { data } = await axios.post(
          "/roster/updateactualdetail",
          {
            userid: this.userid,
            schedule_id: this.selectedScheduleId,
            detail: {
              ...this.actualDayForm,
              replacement_employee_id: replacementEmployeeId,
            },
          },
          { headers: this.rosterRequestHeaders() }
        );
        if (data.status !== 200) {
          throw new Error(data.message || "Unable to update roster day.");
        }
        this.showActualDayModal = false;
        await this.loadRosterView(this.selectedScheduleId);
      } catch (error) {
        console.error("Actual roster day update failed", error.response || error);
        alert(error.message || "Unable to update roster day.");
      } finally {
        this.isSavingActualDay = false;
      }
    },
    openWorkIdModal() {
      this.workIdForm = {
        worksite: this.searchForm.worksite || (this.worksites.length ? this.worksites[0] : null),
        pattern: this.clonePatternOption(this.patterns.length ? this.patterns[0] : null),
        work_id_code: this.workIdForm.work_id_code || this.teamEmployeeForm.work_id_code || "",
        position: "",
      };
      this.showWorkIdModal = true;
    },
    openWorksiteModal() {
      this.worksiteForm = {
        work_site_code: this.worksiteForm.work_site_code || "",
        work_site_name: "",
        site_address: "",
        site_contact: "",
      };
      this.showWorksiteModal = true;
      this.worksiteModalKey += 1;
    },
    async searchMonthlyRoster() {
      if (!this.searchForm.worksite) return;
      const params = new URLSearchParams({
        worksite_id: this.searchForm.worksite.value,
        year: this.searchForm.year,
        month: this.searchForm.month,
      });
      if (this.isViewMode && this.selectedScheduleId) {
        params.set("schedule_id", this.selectedScheduleId);
      }
      try {
        const { data } = await axios.get(this.monthlyEndpoint + "?" + params.toString(), { headers: this.rosterRequestHeaders() });
        this.monthlySummary = {
          worksite: data.worksite || null,
          schedule: data.schedule || null,
          month_label: data.month_label || this.selectedMonthLabel,
        };
        if (data.schedule && data.schedule.id) {
          this.selectedScheduleId = data.schedule.id;
          if (this.isAiRoster) {
            this.applyAiCriteriaFromSchedule(data.schedule);
          }
        }
        this.rosterRows = (data.roster_rows || []).map((row) => ({
          ...row,
          pattern: this.clonePatternOption(this.patterns.find((item) => item.value === row.pattern_id) || row.pattern || null),
          employee: this.employees.find((item) => item.value === row.employee_id) || row.employee || null,
          position: this.isAiRoster ? "" : (row.position || ""),
        }));
        this.rosterSearchSnapshot = JSON.parse(JSON.stringify(this.rosterRows));
        this.leaveRows = data.leave_rows || [];
      } catch (error) {
        console.log(error.response || error);
        this.monthlySummary = {
          worksite: this.searchForm.worksite || null,
          schedule: null,
          month_label: this.selectedMonthLabel,
        };
        this.rosterRows = [];
        this.rosterSearchSnapshot = [];
        this.leaveRows = [];
      }
    },
    async saveRosterAssignments() {
      if (this.isSavingRoster) {
        console.warn("Roster create request is already running.");
        return;
      }
      this.isSavingRoster = true;
      try {
        if (this.isAiRoster) {
          this.scheduleForm.worksite = this.searchForm.worksite;
          this.scheduleForm.year = this.searchForm.year;
          this.scheduleForm.month = this.searchForm.month;
          if (!this.scheduleForm.pattern) {
            const firstPatternRow = this.rosterRows.find((row) => row.pattern && row.pattern.value);
            this.scheduleForm.pattern = this.clonePatternOption(firstPatternRow ? firstPatternRow.pattern : (this.patterns[0] || null));
          }
          const scheduleId = await this.saveSchedule(false, true);
          if (!scheduleId) {
            alert("Unable to create AI roster schedule.");
            return;
          }
          this.selectedScheduleId = scheduleId;
          this.viewMode = true;
          await this.loadRosterView(scheduleId);
          this.$router.push({ path: "/roster/ai/view", query: { id: scheduleId } });
          return;
        }

        if (!this.rosterRows.length) {
          console.warn("No roster rows available to save.");
          return;
        }
        if (!this.scheduleForm.pattern) {
          const firstPatternRow = this.rosterRows.find((row) => row.pattern && row.pattern.value);
          this.scheduleForm.pattern = this.clonePatternOption(firstPatternRow ? firstPatternRow.pattern : (this.patterns[0] || null));
        }
        const createdScheduleId = await this.saveSchedule(false, true);
        if (!createdScheduleId) {
          console.error("Roster schedule could not be created.");
          return;
        }
        this.selectedScheduleId = createdScheduleId;
        const rows = this.rosterRows.map((row) => ({
          id: row.team_employee_id,
          worksite_id: this.scheduleForm.worksite ? this.scheduleForm.worksite.value : (this.searchForm.worksite ? this.searchForm.worksite.value : 0),
          work_id_code: row.work_id_code,
          pattern_id: row.pattern ? row.pattern.value : 0,
          employee_id: row.employee ? row.employee.value : 0,
          position: row.position,
        }));
        console.log("Saving roster assignments...", rows);
        const { data } = await axios.post(
          "/roster/updateteamemployees",
          { userid: this.userid, rows },
          { headers: this.rosterRequestHeaders() }
        );
        if (data.status === 200) {
          console.log("Roster assignments saved successfully.", data);
          // const detailsSaved = await this.saveCreatedRosterDetails(createdScheduleId);
          // if (!detailsSaved) {
          //   console.error("Roster schedule was created, but schedule detail rows could not be saved.");
          //   return;
          // }
          const scheduleId = createdScheduleId;
          if (scheduleId) {
            this.viewMode = true;
            await this.loadRosterView(scheduleId);
            this.$router.push({ path: this.rosterViewPath, query: { id: scheduleId } });
          } else {
            const worksiteId = this.searchForm.worksite ? this.searchForm.worksite.value : 0;
            if (worksiteId) {
              this.viewMode = true;
              this.$router.push({
                path: this.rosterViewPath,
                query: {
                  worksite_id: worksiteId,
                  year: this.searchForm.year,
                  month: this.searchForm.month,
                },
              });
            } else {
              console.warn("Roster saved, but no worksite was available for redirect.");
            }
          }
        } else {
          console.error("Roster save failed.", data);
        }
      } catch (error) {
        console.error("Roster save error.", error.response || error);
      } finally {
        this.isSavingRoster = false;
      }
    },
    async submitWorkId() {
      if (!this.workIdForm.worksite) return;
      const payload = {
        userid: this.userid,
        team_employee: {
          worksite_id: this.workIdForm.worksite.value,
          pattern_id: this.workIdForm.pattern ? this.workIdForm.pattern.value : 0,
          employee_id: 0,
          work_id_code: this.workIdForm.work_id_code,
          start_code: this.workIdForm.position,
        },
      };
      const { data } = await axios.post("/roster/createteamemployee", payload, { headers: this.rosterRequestHeaders() });
      if (data.status === 200) {
        this.showWorkIdModal = false;
        this.searchForm.worksite = this.workIdForm.worksite;
        this.workIdForm = { worksite: null, pattern: null, work_id_code: "", position: "" };
        await this.loadMasterData();
        await this.searchMonthlyRoster();
      }
    },
    async updateRosterPattern(row, pattern) {
      if (!row || !pattern) return;
      const previousPattern = this.clonePatternOption(row.pattern);
      const previousDays = row.days ? { ...row.days } : {};
      const rowId = Number(row.team_employee_id || 0);
      const rowWorkId = String(row.work_id_code || "");
      const isTargetRow = (item) => {
        if (rowId > 0) {
          return Number(item.team_employee_id || 0) === rowId;
        }
        if (rowWorkId) {
          return String(item.work_id_code || "") === rowWorkId;
        }
        return item === row;
      };
      const nextDays = this.buildPatternDayMap(pattern);
      this.rosterRows = this.rosterRows.map((item) =>
        isTargetRow(item)
          ? {
              ...item,
              pattern: this.clonePatternOption(pattern),
              days: { ...nextDays },
            }
          : item
      );
      if (rowId <= 0) {
        return;
      }
      try {
        const { data } = await axios.post(
          "/roster/updateteamemployees",
          {
            userid: this.userid,
            rows: [
              {
                id: row.team_employee_id,
                worksite_id: this.searchForm.worksite ? this.searchForm.worksite.value : 0,
                work_id_code: row.work_id_code,
                pattern_id: pattern.value,
                employee_id: row.employee ? row.employee.value : 0,
                position: row.position,
              },
            ],
          },
          { headers: this.rosterRequestHeaders() }
        );
        if (data.status === 200) {
      
        } else {
          this.rosterRows = this.rosterRows.map((item) => {
            if (!isTargetRow(item)) {
              return item;
            }
            return {
              ...item,
              pattern: previousPattern,
              days: { ...previousDays },
            };
          });
        }
      } catch (error) {
        this.rosterRows = this.rosterRows.map((item) => {
          if (!isTargetRow(item)) {
            return item;
          }
          return {
            ...item,
            pattern: previousPattern,
            days: { ...previousDays },
          };
        });
        console.log(error.response || error);
      }
    },
    async updateViewRosterAssignments() {
      if (!this.rosterRows.length) {
        console.warn("No roster rows available to update.");
        return;
      }
      const rows = this.rosterRows.map((row) => ({
        id: row.team_employee_id,
        worksite_id: this.searchForm.worksite ? this.searchForm.worksite.value : 0,
        work_id_code: row.work_id_code,
        pattern_id: row.pattern ? row.pattern.value : 0,
        employee_id: row.employee ? row.employee.value : 0,
        position: row.position,
      }));
      try {
        const { data } = await axios.post(
          "/roster/updateteamemployees",
          { userid: this.userid, rows },
          { headers: this.rosterRequestHeaders() }
        );
        if (data.status === 200) {
          await this.loadRosterView(this.selectedScheduleId);
          alert("Roster updated successfully.");
        } else {
          console.error("Roster update failed.", data);
          alert(data.message || "Roster update failed.");
        }
      } catch (error) {
        console.error("Roster update error.", error.response || error);
        alert((error.response && error.response.data && error.response.data.message) || error.message || "Unable to update roster.");
      }
    },
    async submitAiRosterCriteria() {
      if (this.isSavingRoster) {
        return;
      }
      if (!this.searchForm.worksite) {
        alert("Worksite is required.");
        return;
      }

      this.isSavingRoster = true;
      this.aiLoadingProgress = {
        active: true,
        current: 0,
        total: 0,
      };
      try {
        await this.$nextTick();
        this.aiLoadingProgress.total = await this.loadTotalScheduleRosterCount();
        await this.generateAiRosterPreview();
        this.rosterReadCount = {
          current: this.aiLoadingProgress.current,
          total: this.aiLoadingProgress.total,
        };
      } catch (error) {
        console.error("AI roster criteria submit error.", error.response || error);
        alert((error.response && error.response.data && error.response.data.message) || error.message || "Unable to submit AI roster criteria.");
      } finally {
        this.aiLoadingProgress.active = false;
        this.isSavingRoster = false;
      }
    },
    waitForRosterProgressFrame() {
      return new Promise((resolve) => setTimeout(resolve, 35));
    },
    async loadTotalScheduleRosterCount() {
      try {
        const headers = this.rosterRequestHeaders();
        const [normalResponse, aiResponse] = await Promise.all([
          axios.get("/roster/index", { headers }),
          axios.get("/roster/aiindex", { headers }),
        ]);
        const normalRows = normalResponse.data && normalResponse.data.all_data ? normalResponse.data.all_data : [];
        const aiRows = aiResponse.data && aiResponse.data.all_data ? aiResponse.data.all_data : [];
        const beforeCurrentRows = this.filterBeforeCurrentRosterRows([...aiRows, ...normalRows]);
        this.rosterReadListRows = this.normalizeRosterReadListRows(beforeCurrentRows);
        return normalRows.length + aiRows.length;
      } catch (error) {
        console.log(error.response || error);
        this.rosterReadListRows = this.normalizeRosterReadListRows(
          this.filterBeforeCurrentRosterRows(this.activeRosterSummary ? [this.activeRosterSummary] : [])
        );
        return this.rosterRows.length;
      }
    },
    async generateAiRosterPreview() {
      const leaveOutIds = new Set(this.selectedEmployeeIds(this.aiCriteria.leave_out_employee_ids));
      const mustHaveIds = this.selectedEmployeeIds(this.aiCriteria.must_have_employee_ids);
      const nightOnlyIds = new Set(this.selectedEmployeeIds(this.aiCriteria.night_shift_employee_ids));
      const dayOnlyIds = new Set(this.selectedEmployeeIds(this.aiCriteria.day_shift_employee_ids));
      const positionSelectIds = new Set(this.selectedEmployeeIds(this.aiCriteria.position_select_employee_ids));
      const selectedPattern = this.clonePatternOption(this.scheduleForm.pattern || this.patterns[0] || null);
      const yy = String(this.searchForm.year || new Date().getFullYear()).slice(-2);
      const mm = String(this.searchForm.month || new Date().getMonth() + 1).padStart(2, "0");
      const employeeMap = new Map();

      this.employees.forEach((employee) => {
        const employeeId = Number(employee.value || 0);
        if (employeeId > 0 && !leaveOutIds.has(employeeId)) {
          employeeMap.set(employeeId, employee);
        }
      });

      mustHaveIds.forEach((employeeId) => {
        if (!leaveOutIds.has(employeeId) && !employeeMap.has(employeeId)) {
          const employee = this.employees.find((item) => Number(item.value) === employeeId);
          if (employee) {
            employeeMap.set(employeeId, employee);
          }
        }
      });

      this.scheduleForm.worksite = this.searchForm.worksite;
      this.scheduleForm.year = this.searchForm.year;
      this.scheduleForm.month = this.searchForm.month;
      this.scheduleForm.pattern = this.clonePatternOption(selectedPattern);

      const employeesToRead = Array.from(employeeMap.values());
      const rows = [];
      this.aiLoadingProgress.total = this.aiLoadingProgress.total || employeesToRead.length;
      this.aiLoadingProgress.current = 0;
      this.rosterRows = [];
      await this.$nextTick();
      const progressTotal = Math.max(Number(this.aiLoadingProgress.total) || 0, 1);
      const progressSteps = Math.max(employeesToRead.length, 1);

      for (const [index, employee] of employeesToRead.entries()) {
        const employeeId = Number(employee.value || 0);
        const rowPattern = this.aiPatternForEmployee(employeeId, selectedPattern, dayOnlyIds, nightOnlyIds, index);

        rows.push({
          no: index + 1,
          team_employee_id: 0,
          work_id_code: `WK-${yy}${mm}-${String(index + 1).padStart(5, "0")}`,
          pattern_id: rowPattern ? rowPattern.value : 0,
          pattern: rowPattern,
          employee_id: employeeId,
          employee,
          employee_name: employee.label,
          employee_contact_no: "",
          fin_nic: "",
          position: "",
          site: this.searchForm.worksite ? this.searchForm.worksite.label : "",
          days: this.buildAiPreviewDayMap(rowPattern, employeeId, dayOnlyIds, nightOnlyIds),
        });
        this.aiLoadingProgress.current = Math.min(progressTotal, Math.ceil(((index + 1) / progressSteps) * progressTotal));
        await this.waitForRosterProgressFrame();
      }
      this.aiLoadingProgress.current = progressTotal;

      this.rosterRows = rows;
      this.rosterSearchSnapshot = JSON.parse(JSON.stringify(this.rosterRows));
      this.monthlySummary = {
        worksite: this.searchForm.worksite || null,
        schedule: null,
        month_label: this.selectedMonthLabel,
      };
      this.leaveRows = [];
    },
    buildAiPreviewDayMap(pattern, employeeId, dayOnlyIds, nightOnlyIds) {
      const dayMap = {};
      this.monthDays.forEach((day) => {
        if (nightOnlyIds.has(Number(employeeId))) {
          dayMap[day.date] = "N";
        } else if (dayOnlyIds.has(Number(employeeId))) {
          dayMap[day.date] = "D";
        } else {
          dayMap[day.date] = this.resolveRosterDayValue({ pattern, days: {} }, day);
        }
      });
      return dayMap;
    },
    buildRosterDetailRows() {
      const details = [];
      this.rosterRows.forEach((row) => {
        this.monthDays.forEach((day) => {
          const shiftCode = this.resolveRosterDayValue(row, day);
          details.push({
            roster_date: day.date,
            employee_id: row.employee ? row.employee.value : row.employee_id || 0,
            team_employee_id: row.team_employee_id || 0,
            shift_code: shiftCode,
            shift_start: "",
            shift_end: "",
            assignment_type: shiftCode || "normal",
            vacancy_reason: "",
            replacement_employee_id: 0,
            remarks: "",
            status: 1,
          });
        });
      });
      return details;
    },
    async saveCreatedRosterDetails(scheduleId) {
      if (!scheduleId) return false;
      const details = this.buildRosterDetailRows();
      if (!details.length) return true;
      try {
        const { data } = await axios.post(
          this.addDetailEndpoint,
          { userid: this.userid, schedule_id: scheduleId, details },
          { headers: this.rosterRequestHeaders() }
        );
        if (data.status === 200) {
          console.log("Roster schedule details saved successfully.", data);
          return true;
        }
        console.error("Roster detail save failed.", data);
        return false;
      } catch (error) {
        console.error("Roster detail save error.", error.response || error);
        return false;
      }
    },
    async loadRosterList() {
      try {
        const { data } = await axios.get(this.rosterListEndpoint, { headers: this.rosterRequestHeaders() });
        this.rosters = (data.all_data || []).map((row) => ({
          label: `${row.schedule_code} - ${row.worksite} - ${row.year}/${row.month}`,
          value: row.id,
        }));
      } catch (error) {
        console.log(error.response || error);
      }
    },
    async loadRosterView(id) {
      try {
        const { data } = await axios.get(this.rosterViewEndpoint + "?id=" + id, { headers: this.rosterRequestHeaders() });
        this.selectedRoster = data.schedule || null;
        this.selectedDetails = data.details || [];
        this.selectedActions = data.actions || [];
        this.selectedScheduleId = id;
        if (data.schedule) {
          this.searchForm.year = data.schedule.year;
          this.searchForm.month = data.schedule.month;
          this.searchForm.worksite =
            this.worksites.find((item) => item.value === data.schedule.worksite_id) || this.searchForm.worksite;
          this.scheduleForm.worksite = this.searchForm.worksite;
          if (this.isAiRoster) {
            this.applyAiCriteriaFromSchedule(data.schedule);
          }
        }
        await this.searchMonthlyRoster();
      } catch (error) {
        console.log(error.response || error);
      }
    },
    async saveWorksite() {
      try {
        const { data } = await axios.post("/roster/createworksite", { userid: this.userid, worksite: this.worksiteForm }, { headers: this.rosterRequestHeaders() });
        if (data.status === 200) {
          this.worksiteForm = { work_site_code: "", work_site_name: "", site_address: "", site_contact: "" };
          await this.loadMasterData();
          return true;
        }
        alert(data.message || "Work Site Code already exists.");
        console.log(data.errors || data.message || data);
        return false;
      } catch (error) {
        const message =
          (error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
          error.message ||
          "Unable to save work site.";
        alert(message);
        console.log(error.response || error);
        return false;
      }
    },
    async submitWorksite() {
      if (await this.saveWorksite()) {
        this.showWorksiteModal = false;
      }
    },
    async saveTeamEmployee() {
      const payload = {
        userid: this.userid,
        team_employee: {
          worksite_id: this.teamEmployeeForm.worksite ? this.teamEmployeeForm.worksite.value : 0,
          pattern_id: this.teamEmployeeForm.pattern ? this.teamEmployeeForm.pattern.value : 0,
          employee_id: this.teamEmployeeForm.employee ? this.teamEmployeeForm.employee.value : 0,
          work_id_code: this.teamEmployeeForm.work_id_code,
          start_code: this.teamEmployeeForm.start_code,
        },
      };
      const { data } = await axios.post("/roster/createteamemployee", payload, { headers: this.rosterRequestHeaders() });
      if (data.status === 200) {
        await this.loadMasterData();
      }
    },
    async saveSchedule(redirectToView = true, forceCreate = false) {
      if (this.selectedScheduleId && !forceCreate) {
        return this.selectedScheduleId;
      }
      const payload = {
        userid: this.userid,
        force_create: forceCreate ? 1 : 0,
        schedule: {
          schedule_code: forceCreate ? "" : this.scheduleForm.schedule_code,
          worksite_id: this.scheduleForm.worksite ? this.scheduleForm.worksite.value : (this.searchForm.worksite ? this.searchForm.worksite.value : 0),
          pattern_id: this.scheduleForm.pattern ? this.scheduleForm.pattern.value : 0,
          year: this.scheduleForm.year,
          month: this.scheduleForm.month,
          start_code: this.scheduleForm.start_code,
          ...(this.isAiRoster ? this.aiCriteriaPayload() : {}),
        },
      };
      const { data } = await axios.post(this.createScheduleEndpoint, payload, { headers: this.rosterRequestHeaders() });
      if (data.status === 200) {
        this.selectedScheduleId = data.schedule.id;
        await this.loadRosterList();
        if (redirectToView) {
          this.viewMode = true;
          await this.loadRosterView(this.selectedScheduleId);
          this.$router.push(this.rosterViewPath + "?id=" + data.schedule.id);
        }
        return this.selectedScheduleId;
      }
      return 0;
    },
    addDetailRow() {
      this.detailRows.push({ ...this.detailRow });
      this.detailRow = {
        roster_date: "",
        employee: null,
        team_employee: null,
        shift_code: "",
        shift_start: "",
        shift_end: "",
        assignment_type: "normal",
        vacancy_reason: "",
        replacement_employee: null,
        remarks: "",
        status: 1,
      };
    },
    async saveDetails() {
      if (!this.selectedScheduleId) return;
      const details = this.detailRows.map((row) => ({
        roster_date: row.roster_date,
        employee_id: row.employee ? row.employee.value : 0,
        team_employee_id: row.team_employee ? row.team_employee.value : 0,
        shift_code: row.shift_code,
        shift_start: row.shift_start,
        shift_end: row.shift_end,
        assignment_type: row.assignment_type,
        vacancy_reason: row.vacancy_reason,
        replacement_employee_id: row.replacement_employee ? row.replacement_employee.value : 0,
        remarks: row.remarks,
        status: row.status,
      }));
      const { data } = await axios.post(
        this.addDetailEndpoint,
        { userid: this.userid, schedule_id: this.selectedScheduleId, details },
        { headers: this.rosterRequestHeaders() }
      );
      if (data.status === 200) {
        this.detailRows = [];
        await this.loadRosterView(this.selectedScheduleId);
      }
    },
    async saveAction() {
      if (!this.actionForm.schedule) return;
      const payload = {
        userid: this.userid,
        action: {
          roster_schedule_id: this.actionForm.schedule.value,
          action_type: this.actionForm.action_type,
          employee_id: this.actionForm.employee ? this.actionForm.employee.value : 0,
          replacement_employee_id: this.actionForm.replacement_employee ? this.actionForm.replacement_employee.value : 0,
          from_worksite_id: this.actionForm.from_worksite ? this.actionForm.from_worksite.value : 0,
          to_worksite_id: this.actionForm.to_worksite ? this.actionForm.to_worksite.value : 0,
          action_date: this.actionForm.action_date,
          remarks: this.actionForm.remarks,
        },
      };
      const { data } = await axios.post("/roster/addaction", payload, { headers: this.rosterRequestHeaders() });
      if (data.status === 200) {
        await this.loadRosterView(data.action.roster_schedule_id);
      }
    },
    async confirmSchedule() {
      if (!this.selectedScheduleId) return;
      const { data } = await axios.post("/roster/confirm", { userid: this.userid, id: this.selectedScheduleId, ai_roster: 1 }, { headers: this.rosterRequestHeaders() });
      if (data.status === 200) {
        await this.loadRosterList();
        if (data.actual_schedule && data.actual_schedule.id) {
          const actualId = data.actual_schedule.id;
          this.$router.push({ path: "/roster/ai/actual/view", query: { id: actualId } });
        } else {
          await this.loadRosterView(this.selectedScheduleId);
        }
      }
    },
    async nextMonth() {
      if (!this.selectedScheduleId) return;
      const { data } = await axios.post("/roster/nextmonth", { userid: this.userid, id: this.selectedScheduleId }, { headers: this.rosterRequestHeaders() });
      if (data.status === 200) {
        await this.loadRosterList();
        await this.loadRosterView(data.schedule.id);
        this.$router.push("/roster/view?id=" + data.schedule.id);
      }
    },
  },
};
</script>

<style scoped>
.title-strip {
  background: #a7a7a7;
  color: #111;
  font-weight: 700;
  padding: 6px 13px;
  border-radius: 2px;
  min-width: 220px;
}

.breadcrumb-bar {
  background: #007bff;
  color: #fff;
  padding: 8px 14px;
  font-weight: 700;
  margin-bottom: 10px;
}

.breadcrumb-trail {
  font-size: 14px;
}

.btn-back {
  border-color: #fff;
  color: #fff;
}

.btn-back:hover {
  background: #fff;
  color: #007bff;
}

.action-strip {
  background: #eaf4ff;
  border: 1px solid #d2e3f7;
  padding: 10px 12px;
  border-radius: 0 0 8px 8px;
  margin-bottom: 10px;
}

.search-wrap {
  width: 220px;
}

.search-input {
  border-radius: 12px;
}

.item-text {
  font-size: 14px;
  color: #2b2b2b;
}

.section-banner {
  background: #a9d2e3;
  color: #111;
  font-weight: 700;
  padding: 6px 10px;
  border: 1px solid #95c4d8;
}

.leave-grid thead th {
  background: #b9e3f1;
  color: #111;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
}

.leave-grid tbody td {
  background: #dbeef7;
}

.roster-panel {
  border: 1px solid #d8e3f0;
  border-radius: 16px;
  padding: 14px 10px 10px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
}

.roster-title {
  font-weight: 700;
  color: #0c3d89;
  margin-bottom: 12px;
}

.roster-title-with-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.roster-info-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #4a67a3;
  background: linear-gradient(180deg, #eef5ff 0%, #9ebdff 100%);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 2px rgba(15, 23, 42, 0.25);
  cursor: pointer;
  padding: 0;
}

.roster-info-btn .fa {
  font-size: 15px;
  text-shadow: 0 1px 1px rgba(0, 43, 120, 0.5);
}

.roster-read-count-modal {
  text-align: center;
  padding: 10px 0 4px;
}

.roster-read-count-value {
  color: #0c3d89;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.roster-read-count-label {
  color: #4b5563;
  font-size: 12px;
  margin-top: 6px;
}

.roster-read-list-table th {
  background: #e8f3ff;
  color: #0c3d89;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

.roster-read-list-table td {
  color: #111827;
  font-size: 12px;
  min-width: 130px;
  vertical-align: top;
  white-space: normal;
}

.roster-grid thead th {
  background: #bfe4f6;
  color: #111;
  text-align: center;
  font-weight: 700;
  vertical-align: middle;
  white-space: nowrap;
}

.sticky-col {
  min-width: 90px;
  white-space: nowrap;
  vertical-align: middle !important;
}

.day-head {
  min-width: 34px;
  max-width: 34px;
  width: 34px;
  padding: 4px 2px !important;
  font-size: 11px;
}

.weekend-head {
  background: #d50000 !important;
  color: #fff !important;
}

.day-cell {
  min-width: 34px;
  max-width: 34px;
  width: 34px;
  text-align: center;
  font-weight: 700;
  padding: 4px 2px !important;
  font-size: 12px;
}

.day-cell-clickable {
  cursor: pointer;
}

.day-cell-clickable:hover {
  background: #e8f3ff;
}

.weekend-cell {
  background: #fff4f4;
}

.cell-input {
  min-height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  padding: 4px 8px;
}

.roster-inline-input {
  min-width: 90px;
}

.roster-inline-select {
  min-width: 220px;
  width: 100%;
}

.roster-pattern-dropdown {
  min-width: 120px;
}

.roster-pattern-dropdown .dropdown-toggle {
  width: 100%;
}

.roster-readonly-value {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  min-width: 120px;
  padding: 0 12px;
  border: 1px solid #b9c9db;
  border-radius: 6px;
  background: #fff;
  color: #1d3557;
  font-size: 13px;
}

.roster-employee-col {
  min-width: 150px;
  width: 150px;
}

.roster-employee-col .roster-readonly-value {
  min-width: 150px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.roster-employee-col:focus-within {
  z-index: 30;
}

.roster-inline-select.vs--open {
  z-index: 1050;
}

.roster-inline-select::v-deep .vs__dropdown-toggle {
  min-height: 30px;
  overflow: hidden;
  background: #fff;
}

.roster-inline-select::v-deep .vs__selected-options {
  min-width: 0;
  overflow: hidden;
}

.roster-inline-select::v-deep .vs__selected {
  display: block;
  max-width: 165px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.roster-inline-select::v-deep .vs__dropdown-menu {
  min-width: 230px;
  max-height: 240px;
  z-index: 3000;
}

.roster-toolbar {
  row-gap: 0.5rem;
}

.ai-roster-criteria {
  align-items: flex-start;
  padding: 2px 0 8px;
}

.ai-roster-criteria-field {
  min-width: 210px;
}

.ai-roster-submit-wrap {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  min-width: 160px;
}

.ai-roster-submit-btn {
  min-width: 96px;
  height: 32px;
  margin-top: 21px;
}

.ai-loading-card {
  margin: 12px 0 16px;
}

.ai-loading-body {
  min-height: 66px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.ai-loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #d7e9ff;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: aiRosterSpin 0.75s linear infinite;
}

.ai-loading-progress {
  color: #003b87;
  font-size: 12px;
  font-weight: 700;
}

@keyframes aiRosterSpin {
  to {
    transform: rotate(360deg);
  }
}

.ai-criteria-select {
  min-width: 200px;
}

.ai-criteria-select::v-deep .vs__dropdown-toggle {
  min-height: 30px;
  background: #fff;
  border: 1px solid #cfd7df;
  border-radius: 13px;
  padding: 8px 10px 3px 10px;
  align-items: flex-start;
}

.ai-criteria-select::v-deep .vs__selected-options {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 4px;
  padding: 0;
}

.ai-criteria-select::v-deep .vs__selected {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  max-width: none;
  min-height: 22px;
  margin: 0;
  padding: 0;
  gap: 12px;
  color: #2b2f33;
  background: transparent;
  border: 0;
  font-size: 13px;
  line-height: 1.25;
  white-space: normal;
}

.ai-criteria-select::v-deep .vs__deselect {
  color: #a64b61;
  fill: #a64b61;
  margin: 0;
  padding: 0;
}

.ai-criteria-select::v-deep .vs__search,
.ai-criteria-select::v-deep .vs__search:focus {
  width: 100%;
  margin: 0;
  padding: 0;
}

::v-deep .ai-employee-dropdown-menu {
  font-size: 13px !important;
  line-height: 1.25;
}

::v-deep .ai-employee-dropdown-menu .vs__dropdown-option {
  padding: 5px 12px;
}

.roster-action-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}

.roster-action-btn {
  white-space: nowrap;
}

.roster-table-shell {
  border: 1px solid #d8e3f0;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
}

.roster-table-scroll {
  margin-bottom: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.roster-grid {
  margin-bottom: 0;
  font-size: 0.875rem;
}

.roster-grid th,
.roster-grid td {
  border-color: #d7e2ee !important;
}

.roster-summary-card {
  border: 1px solid #d6e3f2;
  background: #fff;
}

.roster-summary-table {
  overflow: hidden;
  font-size: 0.9rem;
  background: #fff;
}

.roster-summary-table th {
  width: 180px;
  background: #f7fbff;
  font-weight: 700;
  color: #2f3e4e;
  padding: 0.45rem 0.6rem;
  width: 190px;
}

.roster-summary-table td {
  background: #ffffff;
  padding: 0.45rem 0.6rem;
  color: #111;
}

.roster-summary-table tr:nth-child(odd) th,
.roster-summary-table tr:nth-child(odd) td {
  background: #ddeffc;
}

.roster-summary-body {
  padding-top: 0.5rem;
}

.roster-changes-card {
  border: 1px solid #d6e3f2;
  background: #fff;
}

.roster-section-title {
  font-weight: 700;
  color: #0c3d89;
  font-size: 16px;
}

.roster-change-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  align-items: center;
}

.roster-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 12px;
  color: #203040;
  white-space: nowrap;
}

.roster-legend-swatch {
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  display: inline-block;
}

.roster-change-grid {
  margin-bottom: 0;
  font-size: 0.875rem;
}

.roster-change-grid thead th {
  background: #bfe4f6;
  color: #111;
  text-align: center;
  font-weight: 700;
  vertical-align: middle;
  white-space: nowrap;
}

.roster-change-grid tbody td {
  vertical-align: middle;
}

.change-row-vacancy td {
  background: #7f7f7f !important;
  color: #fff !important;
}

.change-row-medical td {
  background: #f2e700 !important;
  color: #222 !important;
}

.change-row-leave td {
  background: #ef5350 !important;
  color: #fff !important;
}

.change-row-training td {
  background: #4a73ff !important;
  color: #fff !important;
}

.change-row-transfer td {
  background: #7be03f !important;
  color: #fff !important;
}

.change-row-default td {
  background: #f5f7fb !important;
  color: #1f2937 !important;
}

.roster-view-grid .sticky-col {
  background: #fff;
}

.roster-view-grid thead th {
  background: #1F4E79 !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: normal;
}

.roster-view-grid thead th.sticky-col {
  background: #1F4E79 !important;
}

.roster-view-grid thead th.weekend-head {
  background: #d50000 !important;
  color: #fff !important;
}

.roster-view-grid thead th.day-head {
  min-width: 34px;
  max-width: 34px;
  width: 34px;
  padding: 4px 2px !important;
  color: #fff !important;
}

@media (max-width: 767.98px) {
  .roster-panel {
    padding: 12px 8px 8px;
    border-radius: 14px;
  }

  .roster-title {
    font-size: 15px;
    line-height: 1.4;
  }

  .roster-actions {
    text-align: left !important;
  }

  .roster-action-wrap {
    justify-content: flex-start;
  }

  .roster-action-btn {
    width: 100%;
    margin-right: 0 !important;
  }

  .roster-grid {
    min-width: 1230px;
    font-size: 11px;
  }

  .roster-summary-table th {
    width: 140px;
  }

  .roster-section-title {
    font-size: 15px;
    margin-bottom: 0.35rem;
  }

  .roster-change-legend {
    gap: 0.5rem 0.75rem;
  }

  .roster-legend-item {
    font-size: 11px;
  }

  .sticky-col {
    min-width: 84px;
  }

  .day-head,
  .day-cell {
    min-width: 32px;
    max-width: 32px;
    width: 32px;
  }

  .roster-inline-input {
    min-width: 100px;
  }

  .roster-inline-select {
    min-width: 210px;
  }

  .roster-grid th,
  .roster-grid td {
    padding: 0.32rem 0.28rem;
  }

  .roster-grid th:nth-child(1),
  .roster-grid td:nth-child(1) {
    position: sticky;
    left: 0;
    z-index: 6;
    background: #fff;
    min-width: 54px;
  }

  .roster-grid th:nth-child(2),
  .roster-grid td:nth-child(2) {
    position: sticky;
    left: 54px;
    z-index: 6;
    background: #fff;
    min-width: 90px;
  }

  .roster-grid th:nth-child(3),
  .roster-grid td:nth-child(3) {
    position: sticky;
    left: 144px;
    z-index: 6;
    background: #fff;
    min-width: 110px;
  }

  .roster-grid th:nth-child(4),
  .roster-grid td:nth-child(4) {
    position: sticky;
    left: 254px;
    z-index: 6;
    background: #fff;
    min-width: 230px;
  }

  .roster-grid th:nth-child(5),
  .roster-grid td:nth-child(5) {
    position: sticky;
    left: 484px;
    z-index: 6;
    background: #fff;
    min-width: 90px;
  }

  .roster-grid thead th:nth-child(-n + 5) {
    z-index: 7;
  }
}

@media (max-width: 575.98px) {
  .roster-panel {
    padding: 10px 6px 6px;
  }

  .roster-title {
    font-size: 14px;
  }

  .roster-grid {
    min-width: 1270px;
  }
}
</style>

<style>
.ai-employee-dropdown-menu {
  font-size: 13px !important;
  line-height: 1.2 !important;
}

.ai-employee-dropdown-menu .vs__dropdown-option {
  font-size: 13px !important;
  line-height: 1.2 !important;
  padding: 4px 10px !important;
}


</style>
